import type { DispatchControl } from "@/types/simpego-api";

export type DispatchRecipient = DispatchControl["contract"];

export interface OfferDispatchSnapshot {
  contract: DispatchRecipient;
  damages: DispatchRecipient | null;
  email: DispatchRecipient;
  offerEmail: DispatchRecipient | null;
  invoice: DispatchRecipient | null;
  reminder: DispatchRecipient | null;
}

// Which categories the offer had set to "none": only these offer "keine" in the dropdowns, for everyone else it stays hidden.
export interface NoneOffered {
  contract: boolean;
  invoice: boolean;
  email: boolean;
}

export const noneOffered = (snapshot: OfferDispatchSnapshot | null): NoneOffered => ({
  contract: snapshot?.contract === "none",
  invoice: snapshot?.invoice === "none" || snapshot?.reminder === "none",
  email: snapshot?.email === "none" || snapshot?.offerEmail === "none",
});

export const snapshotFromOffer = (
  dispatchControl: DispatchControl | undefined,
  contract: DispatchRecipient,
  email: DispatchRecipient
): OfferDispatchSnapshot | null => {
  if (!dispatchControl) return null;

  return {
    contract,
    damages: dispatchControl.damages ?? null,
    email,
    offerEmail: dispatchControl.offerEmail ?? null,
    invoice: dispatchControl.invoice ?? null,
    reminder: dispatchControl.reminder ?? null,
  };
};

interface BuildDispatchControlInput {
  contract: DispatchRecipient;
  invoice: DispatchRecipient;
  reminder: DispatchRecipient;
  email: DispatchRecipient;
  agentEmail: string | null;
  snapshot: OfferDispatchSnapshot | null;
}

export const buildDispatchControl = ({
  contract,
  invoice,
  reminder,
  email,
  agentEmail,
  snapshot,
}: BuildDispatchControlInput): DispatchControl => {
  const damages = snapshot && snapshot.contract === contract ? snapshot.damages : null;
  const offerEmail = snapshot && snapshot.email === email && snapshot.offerEmail ? snapshot.offerEmail : email;

  return {
    contract,
    invoice,
    reminder,
    offerEmail,
    orderEmail: email,
    ...(damages ? { damages } : {}),
    agentEmail: agentEmail || undefined,
  };
};
